import React, { Component } from 'react';
import './style.scss';
import { compose } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import { CounterInput, Checkbox, Icon, SelectGroup } from 'components';
import withLaunchDarkly from 'hocs/withLaunchDarkly';

const OFFICE_CHAT_DESCRIPTION = 'Messaging between Administrators & Families, excluding classroom Teachers.';
const CLASSROOM_CHAT_DESCRIPTION = 'Family messaging with assigned Teachers & Administrators.';

class MessageStep extends Component {
  constructor(props) {
    super(props);
  }
  @bind
  onChange(field) {
    return val => {
      this.props.onUpdateForm({ [field]: val });
    };
  }

  @bind
  onUpdateSisoMessage() {
    this.props.onUpdateForm({
      sisoMessage: !this.props.sisoMessage
    });
  }

  @bind
  onUpdateSendSMS() {
    if (!Helpers.checkFeatureAccess('send-sms')) {
      this.props.onClose();
      Helpers.showPremiumModal(true);
      this.props.onUpdateForm({
        sendSMS: false
      });
      return;
    }

    this.props.onUpdateForm({
      sendSMS: !this.props.sendSMS
    });
  }

  renderSMSLabel() {
    const { maxMonthlySms } = this.props;

    return (
      <div className="new-message__form__sms__label">
        <span>
          Send as Emergency SMS Alert (300 characters)
          <br />
          <small>
            Maximum <b>{maxMonthlySms}</b> SMS/month for your plan, contact us for upgrades
          </small>
        </span>
        {!Helpers.checkFeatureAccess('send-sms') && <Icon name="star" size={18} color="#b079c4" />}
      </div>
    );
  }

  render() {
    const { flags, message, sisoMessage, sendSMS, isMessageValid, messageType, isAdmin } = this.props;
    const messageTypeOptions = [
      { label: 'Office Chat (Administrators & Families)', messageType: 'parent_admin_com', testId: 1 },
      { label: 'Classroom Chat (Teachers, Administrators & Families)', messageType: 'general', testId: 2 }
    ];
    return (
      <div className="modal__container new-message__form">
        {flags['staff-message-admin-view-web'] && <div className="message-step__title">{'MESSAGE TO (CHANNEL)'}</div>}
        <div className="form__row">
          <div className={cx('form-input', { 'form-input--invalid': !isMessageValid })}>
            <>
              {flags['staff-message-admin-view-web'] && (
                <>
                  <SelectGroup
                    title="Message Type"
                    className="message-step__dropdown"
                    onChange={this.onChange('messageType')}
                    disabled={!isAdmin}
                    type="radio"
                    checked={messageType}
                    required
                  >
                    {messageTypeOptions.map(r => {
                      return <SelectGroup.Item key={r.label} label={r.label} value={r.messageType} testId={r.testId} />;
                    })}
                  </SelectGroup>
                  <div className="message-step__description">
                    {messageType === 'parent_admin_com' ? OFFICE_CHAT_DESCRIPTION : CLASSROOM_CHAT_DESCRIPTION}
                  </div>
                </>
              )}
              {flags['staff-message-admin-view-web'] && <div className="message-step__header">{'MESSAGE'}</div>}
              <div className="form-input__field" style={{ position: 'relative' }}>
                <CounterInput
                  multiline
                  value={message}
                  onChange={this.onChange('message')}
                  className="new-message__form__textarea"
                  placeholder="Write a message"
                  showCounter={flags['online-parent-messaging-counter-rollout'] && sendSMS}
                  counter={message.length}
                  limit={300}
                  enableTextSelection={true}
                  reduxState={this.props.reduxState}
                  currentUser={this.props.currentUser}
                  flags={flags}
                  largeTextArea={true}
                />
              </div>
            </>
            {!isMessageValid && <div className="form-input__validation-text">Cannot be empty</div>}
          </div>
        </div>
        <div className="form__row new-message__form__sms">
          <Checkbox onChange={this.onUpdateSendSMS} checked={sendSMS} label={this.renderSMSLabel()} />
        </div>
        <div className="form__row">
          <Checkbox
            onChange={this.onUpdateSisoMessage}
            checked={sisoMessage}
            label="Show at Sign In-Out Kiosk (Will prompt parent when students are Signed In-Out)"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  maxMonthlySms: state.currentUser.data.current_school.max_monthly_sms,
  reduxState: state,
  currentUser: state.currentUser.data
});

const enhance = compose(withLaunchDarkly, connect(mapStateToProps));
export default enhance(MessageStep);
